
import k from './drummer/kick.wav';
import s from './drummer/snare.wav';
import h from './drummer/hihat.wav';
import r from './drummer/ride.wav';
import c from './drummer/crash.wav';
import rs from './drummer/rimshot.wav';

export const kick = k;
export const snare = s;
export const hihat = h;
export const ride = r;
export const crash = c;
export const rimshot = rs;
export const drumset = [kick, snare, hihat, ride, crash, rimshot];


//////////////////
// WEBPACK FOOTER
// ./node_modules/jazzband/demo/samples/drumset.js
// module id = 200
// module chunks = 0